// 第1张
const imgAllA = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725006663974/Frame%201000009036%20(1).jpg',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725087585424/eu1.jpg',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725087585256/uk1.jpg',
        h5: '',
    },
};
export const imgLocaleA: any = {
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
};

// 第2张
const imgAllB = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724665566358/a1.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1724665556370/a2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724665556174/a3.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725088014831/euPC1.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1725522526378/pad.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725522526334/h5.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725088014487/ukPC1.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1725523297610/pad_uk.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725523297428/pad_h5.jpg',
    },
};
export const imgLocaleB: any = {
    us: imgAllB.NA,
    ca: imgAllB.NA,
    br: imgAllB.NA,
    mx: imgAllB.NA,
    uk: imgAllB.UK,
    eu: imgAllB.EU,
    de: imgAllB.EU,
    fr: imgAllB.EU,
    it: imgAllB.EU,
    es: imgAllB.EU,
};

// 第3张
const imgAllC = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725263154777/d3o_logo_na.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725263307233/d3p_logo_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725263575707/d3p_logo_uk.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1750995921451/D3.png',
        h5: '',
    },
};
export const imgLocaleC: any = {
    jp: imgAllC.NA,
    us: imgAllC.NA,
    ca: imgAllC.NA,
    uk: imgAllC.UK,
    eu: imgAllC.EU,
    de: imgAllC.EU,
    fr: imgAllC.EU,
    it: imgAllC.EU,
    es: imgAllC.EU,
    ph: imgAllC.PH,
};

// 第4张
const imgAllD = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724664510117/aa2.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725157172663/eu2.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725163291084/uk2.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1750995921716/D3P%2BLOGO.png',
        h5: '',
    },
};
export const imgLocaleD: any = {
    jp: imgAllD.NA,
    us: imgAllD.NA,
    br: imgAllD.NA,
    mx: imgAllD.NA,
    ca: imgAllD.NA,
    uk: imgAllD.UK,
    eu: imgAllD.EU,
    de: imgAllD.EU,
    fr: imgAllD.EU,
    it: imgAllD.EU,
    es: imgAllD.EU,
    ph: imgAllD.PH,
};
